import { RoutePendingSkeleton } from "@/components/pageSkeletons";
import { ErrorPage } from "@/errors/ErrorPage";

/** Router defaults shared by the app entry and route tests. */
export const routerDefaults = {
  defaultPendingComponent: RoutePendingSkeleton,
  // Any route that throws lands here, so no page can blank the app.
  defaultErrorComponent: ErrorPage,
  // TanStack Router waits 1s by default; show pending as soon as a route blocks.
  defaultPendingMs: 0,
  // Avoid a one-frame flash once the route is ready.
  defaultPendingMinMs: 300,
  // Rail links preload on hover and focus. Routes that write in their loader
  // set preload: false so that hover cannot run the write.
  defaultPreload: "intent" as const,
  // Hover or focus must rest this long before a link preloads, so a pointer
  // sweeping across the client list does not load every row it crosses.
  // #513 asks for 100–150 ms; the router's own default is 50 ms.
  defaultPreloadDelay: 120,
  // Router defaults to 30s; React Query owns loader freshness on preload.
  defaultPreloadStaleTime: 0,
};
